export default __webpack_public_path__ + "static/media/gardenMakeover.a63d05e7.jpg";